import { useCallback, useEffect, useState } from "react";
import BarCard from "../../Component/header/BarCard";
import Menu from "../../Component/Menu/Menu";
import './Perfil.css';
import { getPerfilEstablecimiento, getUserInfo, updateestablecimiento } from "../../Servicios/Servicios";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useSpinner } from "../../Component/spinner/spinner";

const containerStyle = {
  width: "60%",
  height: "300px",
};

const PerfilEstablecimiento = () => {
  const [isEditable, setIsEditable] = useState(false);
  const [coordenadas, setCoordenadas] = useState(null);
  const spinner = useSpinner();
  const [establecimientoDat, setEstablecimientoDat] = useState({});
  const [nombreArchivo, setNombreArchivo] = useState('');
  const [imagen, setImagen] = useState(null);
  // Cargar Google Maps
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyC4UwcnlEu-urUoO_1Gpf3fhpOGNPcqvKg", // reemplaza con tu API Key
  });

  // Datos de ejemplo, puedes reemplazarlo con datos reales
  useEffect(() => {
    // Aquí podrías hacer una llamada a la API para obtener los datos del perfil
    getBarDetailsEstablecimiento();
    getUserInformacion();
  }, []);

  // Función para obtener los detalles del bar
  const ActualizarEstablecimiento = ()=> {
    
    setIsEditable(!isEditable);
  
  }
  const GuardarCambios = async () =>{
    
    delete establecimientoDat._id;
    delete establecimientoDat.id
    if(imagen) {establecimientoDat.Imagen = imagen;}
    if(establecimientoData.nombre) {establecimientoDat.Nombre = establecimientoData.nombre;}
    if(establecimientoData.telefono) {establecimientoDat.Telefono = establecimientoData.telefono;}
    if(establecimientoData.correo) {establecimientoDat.Correo = establecimientoData.correo;}
    if(establecimientoData.direccion) {establecimientoDat.Direccion = establecimientoData.direccion;}
    if(establecimientoData.categoria) {establecimientoDat.Categoria = establecimientoData.categoria;}

    const response = await updateestablecimiento(establecimientoDat);
    if ( response.success ){
      alert(response.message || "Cambios guardados exitosamente");
      getBarDetailsEstablecimiento();
      getUserInformacion();

    }else{
      alert(response.message || "Error al guardar los cambios. Por favor, inténtalo de nuevo.");
    }
    setIsEditable(!isEditable);

  }
  
  const convertirImagenABase64 = (e) => {
    spinner.show();
    const file = e.target.files[0];
    if (file.size > 5 * 1024 * 1024) { // 5MB en bytes
      alert("El archivo excede el tamaño máximo permitido (5MB)");
      spinner.hide();
      return;
    }
    if (!file) return;
    setNombreArchivo(file.name);

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onloadend = () => {
      const base64 = reader.result;
      setImagen(base64); // si estás usando useState
      spinner.hide();
    };

    reader.onerror = () => {
      console.error("Error al leer el archivo");
      spinner.hide();
    };
  };

  const getBarDetailsEstablecimiento = async () => {
    spinner.show();
    try {
      // Lógica para obtener detalles del bar, si es necesario  
      const getDetail = await getPerfilEstablecimiento();
      
      if (getDetail.success) {
        spinner.hide();
        let data = getDetail.data.resultados;
        console.log("Detalles del bar obtenidos:", data);
        setEstablecimientoDat(getDetail.data.resultados);
        setEstablecimientoData({
          nombre: data.Nombre,
          telefono: data.Telefono,
          correo: data.email,
          direccion: data.Direccion,
          categoria: data.TipoEstablecimiento,
        });
        const {coordinates} = data.location;
        setCoordenadas({ lat: coordinates[0], lng: coordinates[1] });
        
      }else{
        spinner.hide();
        console.error("Error al obtener los detalles del bar:", getDetail.message);
        alert("Error al cargar los datos del establecimiento. Por favor, inténtalo de nuevo más tarde.");
        setCoordenadas(null);
        setEstablecimientoData({
          nombre: '',
          telefono: '',
          correo: '',
          direccion: '',
          categoria: '',
        });
      }
    } catch (error) {
      spinner.hide();
      setCoordenadas(null);
      console.error("Error al obtener los detalles del bar:", error);
    }
  }
  
  const getUserInformacion = async () => {
    try {
      // Lógica para obtener detalles del usuario, si es necesario  
      const getDetail = await getUserInfo();
      
      if (getDetail.success) {
        let data = getDetail.data.resultados;
        setAdminData({
          nombre: data.first_name + " " + data.last_name,
          celular: data.celular,
          correo: data.username,
        });

      }
    } catch (error) {

      console.error("Error al obtener los detalles del usuario:", error);
    }
  }


  const [adminData, setAdminData] = useState({
    nombre: '',
    celular: '',
    correo: '',
  });

  const [establecimientoData, setEstablecimientoData] = useState({
    nombre: '',
    telefono: '',
    correo: '',
    direccion: '',
    categoria: '',
  });
  
  return (
    <div>
      <div className="h-110 overflow-y-auto m-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[600px] overflow-y-auto">
          {/* Columna Izquierda */}
          <div>
            {/* Datos del Administrador */}
            <div className="mb-6">
              <h2 className="font-semibold mb-2 text-[#4F60A8]">Datos del Administrador</h2>
              <div className="space-y-2">
                <div className="flex items-center">
                  <label className="w-40 font-medium text-sm text-white">Nombre</label>
                  <input
                    type="text"
                    className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
                    onChange={(e) => setAdminData({ ...adminData, nombre: e.target.value })}
                    defaultValue={adminData.nombre}
                    disabled={!isEditable}
                  />
                </div>
                <div className="flex items-center">
                  <label className="w-40 font-medium text-sm text-white">Celular</label>
                  <input
                    type="text"
                    className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
                    onChange={(e) => setAdminData({ ...adminData, celular: e.target.value })}
                    defaultValue={adminData.celular}
                    disabled={!isEditable}
                  />
                </div>
                <div className="flex items-center">
                  <label className="w-40 font-medium text-sm text-white">Correo electrónico</label>
                  <input
                    type="email"
                    className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
                    onChange={(e) => setAdminData({ ...adminData, correo: e.target.value })}
                    defaultValue={adminData.correo}
                    disabled={!isEditable}
                  />
                </div>
              </div>
            </div>

            {/* Datos del Establecimiento */}
            <div className="mb-6">
              <h2 className="font-semibold mb-2 text-[#4F60A8]">Datos del Establecimiento</h2>
              <div className="space-y-2">
                <div className="flex items-center">
                  <label className="w-40 font-medium text-sm text-white">Nombre</label>
                  <input
                    type="text"
                    className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
                    onChange={(e) => setEstablecimientoData({ ...establecimientoData, nombre: e.target.value })}
                    defaultValue={establecimientoData.nombre}
                    disabled={!isEditable}
                  />
                </div>
                <div className="flex items-center">
                  <label className="w-40 font-medium text-sm text-white">Teléfono</label>
                  <input
                    type="text"
                    className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
                    onChange={(e) => setEstablecimientoData({ ...establecimientoData, telefono: e.target.value })}
                    defaultValue={establecimientoData.telefono}
                    disabled={!isEditable}
                  />
                </div>
                <div className="flex items-center">
                  <label className="w-40 font-medium text-sm text-white">Correo electrónico</label>
                  <input
                    type="email"
                    className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
                    onChange={(e) => setEstablecimientoData({ ...establecimientoData, correo: e.target.value })}
                    defaultValue={establecimientoData.correo}
                    disabled={!isEditable}
                  />
                </div>
              </div>
            </div>

            {/* Categoría */}
            <div className="mb-6">
              <h2 className="font-semibold mb-2 text-[#4F60A8]">Categoría a la que pertenece</h2>
              <div className="flex items-center">
                <label className="w-40 font-medium text-sm text-white">Categoría</label>
                <input
                  type="text"
                  className="flex-1 border border-gray-300 rounded px-2 py-1 text-sm"
                  defaultValue={establecimientoData.categoria || "Bar"}
                  onChange={(e) => setEstablecimientoData({ ...establecimientoData, categoria: e.target.value })}
                  disabled={!isEditable}
                />
              </div>
              {isEditable ? (
                <div className="mb-6">
                  <label className="w-40 font-medium text-sm text-white">Nueva Imagen</label>
                  <input 
                    id="file-upload"
                    accept="image/*"
                    onChange={(e) => convertirImagenABase64(e)}
                    type="file"
                    placeholder="Imagen del establecimiento"
                    className="mb-4 py-1 file-input inputwhite"
                  />
                  {nombreArchivo && (
                    <span className="text-sm text-white">📄 {nombreArchivo}</span>
                  )}
                </div>
              ) : null}
            </div>

            {/* Botón */}
            {isEditable ? (
              <>
                <button
                  onClick={() => {setIsEditable(!isEditable); setImagen(null); setNombreArchivo('');}}
                  className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800 transition "
                  
                  >
                  Cancelar
                </button>
                <button onClick={GuardarCambios}
                className="bg-[#4F60A8] text-white px-4 py-2 rounded hover:bg-[#4F60A8]-100 mb-6  transition ml-2 " >Guardar Cambios</button>
              </>

            ) : (
              <button 
                onClick={ActualizarEstablecimiento}
                className="bg-[#4F60A8] text-white px-4 py-2 rounded hover:bg-[#4F60A8]-100 mb-6  transition ml-2 ">
                  
                Actualizar Establecimiento
              </button>
            )}
          </div>

          {/* Columna Derecha */}
          { isLoaded && coordenadas ?
            <div >
              <h2 className="font-semibold mb-2 text-[#4F60A8] text-center">Ubicación del establecimiento</h2>
              <div className="flex justify-center">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={coordenadas}
                  zoom={16}
                  options={{
                    disableDefaultUI: false,
                    zoomControl: true,
                    streetViewControl: false,
                    draggable: false,          // <- evita mover el mapa
                    scrollwheel: false,  
                    mapTypeControl: false,      // <- evita mover con scroll
                  }}
                >
                  <Marker
                    position={coordenadas}
                    icon="https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png"
                    draggable={false} // <- evita mover el marker
                  />
                </GoogleMap>
              </div>
            </div>:
            <div className="text-center text-gray-400 text-xs">
              No tienes ningún evento creado todavía
            </div>
          }
        </div>

      </div>
    </div>
  );
};

export default PerfilEstablecimiento;
